import {useQuery} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {payoutsApi} from '../api';

export const beneficiaryLastAccountKeys = {
  detail: (trustAccountId: string, partyId: string) =>
    ['trust-accounts', trustAccountId, 'beneficiaries', partyId, 'last-account'] as const
};

export function useBeneficiaryLastAccountQuery(
  trustAccountId: string,
  partyId: string,
  options: {enabled: boolean}
) {
  const client = useApiClient();

  return useQuery({
    queryKey: beneficiaryLastAccountKeys.detail(trustAccountId, partyId),
    queryFn: () => payoutsApi.fetchBeneficiaryLastAccount(client, trustAccountId, partyId),
    enabled: options.enabled && !!trustAccountId && !!partyId,
    select: response => response.data
  });
}
